//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "select-company-popup",
    props: {
        value: Boolean,
    },
    data() {
        return {
            options: [],
            cascaderValue: '',
            show: false,
            selectedOptions: [],
            fieldValue: '',
            saveDto: {}
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        onFinish({value, selectedOptions, tabIndex}) {

            // console.log(this.cascaderValue)
            if (tabIndex === 2) {
                this.fieldValue = selectedOptions.map((option) => option.text).join('/');
                this.saveDto.positionId = selectedOptions[2].positionId
                this.saveDto.companyId = selectedOptions[2].companyId
                // this.saveRepairPosition()
                this.$emit('handleSelected', {
                    id: 0,
                    fieldValue: this.fieldValue,
                    positionId:selectedOptions[2].positionId,
                    companyId:selectedOptions[2].companyId
                })
            }
        },
        getList() {
            abp.ajax.get('/api/services/app/RepairPosition/GetPositionAndChildren', {params: {projectId: this.workOrderInfo.projectId}}).then(res => {
                this.options = [];
                this.options.push(...res.data.result);

                this.options.forEach(item => {
                    item.text = item.displayName;
                    item.value = item.id
                    item.children.forEach(childrenItem => {
                        childrenItem.text = childrenItem.displayName;
                        childrenItem.value = childrenItem.id
                        childrenItem.children = null;
                    })
                })
            })
        },

        onChange({value, selectedOptions, tabIndex}) {
            if (tabIndex === 1) {
                this.selectedOptions = [];
                this.selectedOptions = selectedOptions;
                this.getPositionCompanyList(value);
            }
        },

        getPositionCompanyList(positionId) {
            abp.ajax.get('/api/services/app/RepairPosition/GetPositionCompanyList', {params: {positionId: positionId}}).then(res => {
                if (res.data.result) {
                    let list = []
                    list.push(...res.data.result);
                    list.forEach(item => {
                        item.text = item.companyName;
                        item.value = item.id
                    })
                    let pIndex = this.options.findIndex(z => z.id === this.selectedOptions[0].id);
                    let index = this.options[pIndex].children.findIndex(z => z.id === this.selectedOptions[1].id)
                    this.options[pIndex].children[index].children = [];
                    this.options[pIndex].children[index].children = list;
                }
            });
        },

        handleClose() {
            this.$emit('handleClose')
        },
        // saveRepairPosition() {
        //     this.saveDto.workOrderId = this.workOrderInfo.id;
        //     abp.ajax.post('/api/services/app/MicroWorkOrder/SaveRepairPosition', this.saveDto).then(res => {
        //         this.$emit('handleSelected')
        //     }).finally(() => {
        //
        //     })
        // }
    },
    created() {
        this.getList()
    }
}
